import React from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { useApiQuery } from "@pgs-core/portal-lib/hooks";
import { useListControls } from "@pgs-core/portal-lib/list-controls";
import { ClientsPanel } from "../components/clients-panel";
import { fetchClientsPage } from "../lib/clients";
import type { AdminClient, AdminOutletContext } from "../lib/outlet-context";
import {
  canOpenClientPortal,
  openClientPortal,
  openClientPortalTitle,
} from "../lib/open-client-portal";

export function ClientsPage() {
  const { api, user } = useOutletContext<AdminOutletContext>();
  const navigate = useNavigate();

  // The list page fetches its own paged window (search + pagination) rather
  // than reusing the shell's full context list, which serves the breadcrumbs.
  const controls = useListControls();
  const query = useApiQuery(
    () => (api ? fetchClientsPage(api, controls.queryString) : null),
    [api, controls.queryString]
  );

  return (
    <ClientsPanel
      clients={query.data?.clients ?? []}
      loaded={query.data !== null}
      error={query.error}
      total={query.data?.total ?? 0}
      schemaLatest={query.data?.schemaLatest ?? 0}
      controls={controls}
      onViewStatus={(clientId: string) => navigate(`/clients/${clientId}`)}
      onNewClient={() => navigate("/clients/new")}
      onOpenPortal={(client: AdminClient, path?: string) => openClientPortal(client, api, user, path)}
      canOpenPortal={(client: AdminClient) => canOpenClientPortal(client, api)}
      portalTitle={(client: AdminClient) => openClientPortalTitle(client)}
    />
  );
}
